export default __webpack_public_path__ + "static/media/stick.b0a774ae.png";